import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { RemoteTypeLoader, RegexValidator, TypeReader } from "./FTSchemataDef";
import React, { useState, useEffect } from "react";
import { FileProvider } from "./FileContext";

import HomeScreen from "./screens/HomeScreen/HomeScreen";
import ReportImage from "./screens/ReportImage/ReportImage";
import FishInfo from "./screens/FishInfo/FishInfo";
import Anonymity from "./screens/Anonymity/Anonymity";
import UploadFiles from "./screens/UploadFiles/UploadFiles";
import Login from "./screens/Login/LoginPage";
import FinalReview from "./screens/FinalReview/FinalReview";
import Progress from "./screens/Progress/Progress";

function readUserCookie() {
  const rawCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('ft_user_data='))
    ?.split('=')[1];
  if (!rawCookie) return null;
  try {
    return JSON.parse(atob(decodeURIComponent(rawCookie)));
  } catch {
    return null;
  }
}

function getSavedUser() {
  const cookieUser = readUserCookie();
  if (cookieUser) {
    return {
      isLoggedIn: true,
      name: cookieUser.display_name || "",
      accountType: cookieUser.account_type || null,
    };
  }
  try {
    const stored = localStorage.getItem("ft_user");
    if (stored) return JSON.parse(stored);
  } catch {}
  return { isLoggedIn: false, name: "", accountType: null };
}

function App() {
  const [typesLoaded, setTypesLoaded] = useState(false);
  const [types, setTypes] = useState({});
  const [user, setUser] = useState(() => getSavedUser());

  const setUserAndPersist = (newUser) => {
    setUser(newUser);
    if (newUser.isLoggedIn) {
      localStorage.setItem("ft_user", JSON.stringify(newUser));
    } else {
      localStorage.removeItem("ft_user");
    }
  };

  useEffect(() => {
    RemoteTypeLoader.loadNamespaces(["std", "tagapp"], () => {
      console.log("Standard types loaded globally.");

      const loadedTypes = { ...TypeReader.types };
      const emailType = loadedTypes["std.email"];
      if (emailType) {
        emailType.validator_list = emailType.validator_list.filter(
          v => !(v instanceof RegexValidator && v.regex === "placeholder")
        );
        const emailPattern = "^[a-zA-Z0-9]+(?:\\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+\\.[a-zA-Z]{2,}$";
        emailType.validator_list.push(new RegexValidator("std.email", emailPattern));
      }

      setTypes(loadedTypes);
      setTypesLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (typesLoaded) {
      console.log("Updated types in state:", types);
      console.log("std.email exists in state:", types["std.email"]);
    }
  }, [typesLoaded, types]);

  if (!typesLoaded) {
    return <div>Pulling data from FishTagged servers...</div>;
  }

  return (
    <FileProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomeScreen types={types} user={user} setUser={setUserAndPersist} />} />
          <Route path="/anonymity" element={<Anonymity user={user} setUser={setUser} />} />
          <Route path="/uploadFiles" element={<UploadFiles user={user} />} />
          <Route path="/reportImage" element={<ReportImage user={user} />} />
          <Route path="/fishInfo" element={<FishInfo user={user} types={types} />} />
          <Route path="/finalreview" element={<FinalReview user={user} />} />
          <Route path="/progress" element={<Progress user={user} />} />
          <Route
            path="/login"
            element={
              <Login
                user={user}
                onLoginSuccess={(newUser) => {
                  setUserAndPersist({
                    isLoggedIn: true,
                    name: newUser.name,
                    accountType: newUser.accountType || newUser.account_type || null,
                  });
                }}
              />
            }
          />
          <Route
            path="*"
            element={<HomeScreen types={types} user={user} setUser={setUserAndPersist} />}
          />
        </Routes>
      </Router>
    </FileProvider>
  );
}

export default App;